var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseOffSwitch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.757 4.757a.857.857 0 0 0 0 1.213L7.787 9l-3.03 3.03a.857.857 0 0 0 1.212 1.213L9 10.213l3.03 3.03a.857.857 0 1 0 1.213-1.213L10.213 9l3.03-3.03a.857.857 0 0 0-1.213-1.213L9 7.787l-3.03-3.03a.857.857 0 0 0-1.213 0",
  clipRule: "evenodd"
})));
export default SvgCloseOffSwitch;